module.exports = __webpack_public_path__ + "static/media/horizontal-align-left.f482724e.svg";